import permissions from '@/enums/permissions';

const settlementReconciliation = [
    {
        path: '/conciliacao-liquidacoes',
        name: 'settlement-reconciliation',
        component: () => import('@/views/pages/SettlementReconciliation/SettlementReconciliation.vue'),
        meta: {
            permissions: permissions.settlementReconciliation,
        },
    },
];

export default settlementReconciliation;
